import { Button, Modal, Radio, Row, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import FormItem from "antd/es/form/FormItem";
import { FormInput } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useTranslation } from "react-i18next";
import { useState } from "react";

const SendMail50BisModal = ({
    isSendMailModalOpen = false,
    setIsSendMailModalOpen = () => { },
    selectedRecord = {},
    sendSection50BisReportReportPdf = () => { }
}) => {
    const { t, i18n } = useTranslation();
    const [form] = useForm();
    const [selectedEmailType, setSelectedEmailType] = useState("email");

    const handleSubmit = (values) => {
        let email;

        if (selectedEmailType === "email") {
            email = selectedRecord?.email;
        } else if (selectedEmailType === "personalEmail") {
            email = selectedRecord?.personalEmail;
        } else if (selectedEmailType === "custom") {
            email = values.custom;
        }
        // let idEmployee = selectedRecord.employeeId
        sendSection50BisReportReportPdf({ ...selectedRecord, email })
        setIsSendMailModalOpen(false);
        setSelectedEmailType("email");
        form.resetFields();
    };

    const handleCancel = () => {
        setIsSendMailModalOpen(false);
        setSelectedEmailType("email");
        form.resetFields();
    };

    return (
        <Modal
            open={isSendMailModalOpen}
            title={t("action.sende_email_50_bis")}
            closable={false}
            maskClosable={false}
            footer={false}
            destroyOnClose
        >
            <FormAntd
                form={form}
                onFinish={handleSubmit}
            >
                <Space direction="vertical" size={24} style={{ width: "100%" }}>
                    <Radio.Group
                        value={selectedEmailType}
                        onChange={(e) => setSelectedEmailType(e.target.value)}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 8,
                        }}
                    >
                        <Radio value="email">
                            {`${t("company_profile.label.email")} (${selectedRecord?.email || "-"})`}
                        </Radio>
                        <Radio value="personalEmail" disabled={selectedRecord?.personalEmail == null}>
                            {`${t("employee.personal-email")} (${selectedRecord?.personalEmail || "-"})`}
                        </Radio>
                        <Radio value="custom">
                            <FormInput
                                name="custom"
                                label={t("employmentType.radio.custom")}
                                vertical={false}
                                width="300px"
                                placeholder={t("common.please_fill")}
                                disabled={selectedEmailType !== "custom"}
                            />
                        </Radio>
                    </Radio.Group>

                    <Row justify="end" style={{ gap: "12px" }}>
                        <Button
                            type="default"
                            onClick={handleCancel}
                            size="large"
                        >
                            {t("common.cancel")}
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{ backgroundColor: "var(--button-color)" }}
                            size="large"
                        >
                            {t("confirm")}
                        </Button>
                    </Row>
                </Space>
            </FormAntd>
        </Modal>
    )
}

export default SendMail50BisModal;